import React from "react";

import { Adsense } from "@ctrl/react-adsense";

const GoogleAd = () => {
  return <Adsense client="ca-pub-7406814726738648" slot="5168933484" />;
};

export default GoogleAd;
